"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var interfaces_1 = require("./interfaces");
var uuid_1 = require("uuid");
var safe_json_stringify_1 = __importDefault(require("safe-json-stringify"));
var utils_1 = require("./utils");
var log_uploader_1 = __importDefault(require("./log-uploader"));
var LOG_LEVELS = Object.keys(interfaces_1.LogLevels);
var PAYLOAD_TOO_LARGE = 413;
var MAX_LOG_SIZE = 14500;
var ENVIRONMENTS = [
    'mypurecloud.com',
    'mypurecloud.com.au',
    'mypurecloud.jp',
    'mypurecloud.de',
    'mypurecloud.ie',
    'usw2.pure.cloud',
    'cac1.pure.cloud',
    'euw2.pure.cloud',
    'apne2.pure.cloud'
];
var Logger = /** @class */ (function () {
    function Logger() {
        this.logBufferSize = 0;
        this.logBuffer = [];
        this.logRequestPending = false;
        this.failedLogAttempts = 0;
        this.isInitialized = false;
        Object.defineProperty(this, 'clientId', {
            value: uuid_1.v4(),
            writable: false
        });
    }
    Logger.prototype.initializeServerLogging = function (opts) {
        if (this.isInitialized) {
            throw new Error('Server logging already initialized');
        }
        this.opts = opts;
        var logLevel = opts.logLevel;
        if (LOG_LEVELS.indexOf(logLevel) === -1) {
            if (logLevel) {
                this.warn("Invalid log level: '" + logLevel + "'. Default '" + interfaces_1.LogLevels.info + "' will be used instead.", null, true);
            }
            this.opts.logLevel = interfaces_1.LogLevels.info;
        }
        if (!opts.environment) {
            this.warn('Possible environments: ', ENVIRONMENTS, true);
            throw new Error('An environment must be provided to do server logging.');
        }
        if (!ENVIRONMENTS.includes(opts.environment)) {
            this.warn('Unknown environment', null, true);
        }
        if (!opts.accessToken) {
            throw new Error('Must provide an accessToken for server uploads');
        }
        log_uploader_1.default.setEnvironment(opts.environment);
        this.isInitialized = true;
    };
    Logger.prototype.log = function (message, details, skipServer) {
        this.processLog(interfaces_1.LogLevels.log, message, details, skipServer);
    };
    Logger.prototype.debug = function (message, details, skipServer) {
        this.processLog(interfaces_1.LogLevels.debug, message, details, skipServer);
    };
    Logger.prototype.info = function (message, details, skipServer) {
        this.processLog(interfaces_1.LogLevels.info, message, details, skipServer);
    };
    Logger.prototype.warn = function (message, details, skipServer) {
        this.processLog(interfaces_1.LogLevels.warn, message, details, skipServer);
    };
    Logger.prototype.error = function (message, details, skipServer) {
        this.processLog(interfaces_1.LogLevels.error, message, details, skipServer);
    };
    Logger.prototype.processLog = function (level, message, details, skipServer) {
        var _a;
        level = (level || interfaces_1.LogLevels.log).toString().toLowerCase();
        if (message instanceof Error) {
            details = details || message;
            message = message.message;
        }
        // immediately log it locally
        var prefix = ((_a = this.opts) === null || _a === void 0 ? void 0 : _a.logTopic) ? "[" + this.opts.logTopic + "] " : '';
        console[level]("" + prefix + message, details);
        if (skipServer ||
            !this.isInitialized ||
            LOG_LEVELS.indexOf(level) < LOG_LEVELS.indexOf(this.opts.logLevel.toString())) {
            return;
        }
        var log = {
            clientTime: new Date().toISOString(),
            clientId: this.clientId,
            message: message,
            details: details
        };
        var logContainer = {
            topic: this.opts.logTopic,
            level: level.toUpperCase(),
            message: safe_json_stringify_1.default(log)
        };
        var logMessageSize = utils_1.calculateLogMessageSize(logContainer);
        var exceedsMaxLogSize = this.logBufferSize + logMessageSize > MAX_LOG_SIZE;
        if (exceedsMaxLogSize) {
            this.info('Log size limit reached, sending immediately', null, true);
            this.notifyLogs(true);
        }
        this.logBuffer.push(logContainer);
        this.logBufferSize += logMessageSize;
        if (!exceedsMaxLogSize) {
            this.notifyLogs(); // debounced call
        }
    };
    Logger.prototype.notifyLogs = function (sendImmediately) {
        if (this.sendLogTimer) {
            clearTimeout(this.sendLogTimer);
        }
        if (sendImmediately) {
            if (!this.logRequestPending) {
                return this.tryToSendLogs();
            }
            else {
                this.info('Tried to send logs immeidately but a send request is already pending. Waiting for pending request to finish', null, true);
            }
        }
        this.sendLogTimer = setTimeout(this.tryToSendLogs.bind(this), this.opts.uploadDebounceTime);
    };
    Logger.prototype.tryToSendLogs = function () {
        if (!this.logRequestPending) {
            this.queueLogsUpload();
        }
    };
    Logger.prototype.queueLogsUpload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var traces, request, error_1, reverseTraces;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        traces = this.getLogPayload();
                        this.logBufferSize = utils_1.calculateLogBufferSize(this.logBuffer);
                        if (traces.length === 0) {
                            return [2 /*return*/, Promise.resolve()];
                        }
                        request = {
                            accessToken: this.opts.accessToken,
                            app: {
                                appId: this.opts.logTopic,
                                appVersion: this.opts.appVersion
                            },
                            traces: traces
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.logRequestPending = true;
                        return [4 /*yield*/, log_uploader_1.default.sendLogs(request)];
                    case 2:
                        _a.sent();
                        this.log('Log data sent successfully', null, true);
                        this.reset();
                        if (this.logBuffer.length) {
                            this.log('Data still left in log buffer, preparing to send again', null, true);
                            this.notifyLogs();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.failedLogAttempts++;
                        if (error_1.status === PAYLOAD_TOO_LARGE) {
                            this.error(error_1, null, true);
                            // If sending a single log is too big, then scrap it and reset backoff
                            if (traces.length === 1) {
                                this.reset();
                                this.notifyLogs();
                                return [2 /*return*/];
                            }
                        }
                        else {
                            this.error('Failed to post logs to server', traces, true);
                        }
                        reverseTraces = traces.reverse();
                        reverseTraces.forEach(function (log) { return _this.logBuffer.unshift(log); });
                        this.logBufferSize = utils_1.calculateLogBufferSize(this.logBuffer);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Logger.prototype.getLogPayload = function () {
        if (!this.logBuffer.length) {
            return [];
        }
        var maxPayloadSize = MAX_LOG_SIZE / (this.failedLogAttempts + 1);
        var currentSize = 0;
        var traces = [];
        for (var _i = 0, _a = this.logBuffer; _i < _a.length; _i++) {
            var trace = _a[_i];
            var size = utils_1.calculateLogMessageSize(trace);
            if (currentSize + size > maxPayloadSize) {
                break;
            }
            currentSize += size;
            traces.push(trace);
        }
        if (traces.length === 0) {
            var firstTrace = this.logBuffer.splice(0, 1);
            this.warn('Message too large to be logged to server', firstTrace, true);
            this.failedLogAttempts = 0;
            return this.getLogPayload();
        }
        this.logBuffer.splice(0, traces.length);
        return traces;
    };
    Logger.prototype.reset = function () {
        this.logRequestPending = false;
        this.failedLogAttempts = 0;
    };
    return Logger;
}());
exports.Logger = Logger;
